<kt-portlet>
  <kt-portlet-header>
    <ng-container ktPortletTitle>
      <h3 class="card-head-title">
        <span>Apartments - Map View</span>
      </h3>
    </ng-container>

    <ng-container ktPortletTools>

    </ng-container>
  </kt-portlet-header>

  <kt-portlet-body>
    <div class="row">
      <kt-filter-section class="col-12" [acType]="1" [filter$]="filter$"
        (filterChange)="onFilterChange($event)"></kt-filter-section>
    </div>

    <div class="row">
      <div class="col-12">
        <mat-form-field class="mat-form-field-fluid">
          <input matInput #search placeholder="Search By Location" autocorrect="off" autocapitalize="off" type="text" />
        </mat-form-field>
      </div>
      <div class="col-12">
        <agm-map [latitude]="centerLat$|async" [longitude]="centerLng$|async" [zoom]="zoom$|async"
          [disableDoubleClickZoom]="true" [clickableIcons]="false" (mapReady)="onMapReady($event)"
          (boundsChange)="onBoundsChange($event)">
          <agm-map-type-control></agm-map-type-control>

          <agm-marker-cluster [calculator]="calculator" [gridSize]="60" [maxZoom]="15"
            imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
            <ng-container *ngFor="let item of (items$|async); trackBy: identity">
              <agm-marker [longitude]="item.value.longitude" [latitude]="item.value.latitude" [label]="item.value.label"
                [iconUrl]="icon"></agm-marker>
            </ng-container>
          </agm-marker-cluster>
        </agm-map>
      </div>
    </div>
  </kt-portlet-body>
</kt-portlet>